import { CSSObject } from "@emotion/react";
import { useId } from "react";

import { paragraphStyles, titleInputStyles } from "./SectionInput.style";

interface SectionInputProps {
  align: "left" | "right" | "center";
  placeholder: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  styleOverrides?: CSSObject;
  isStudent: boolean;
}

const SectionInput = ({
  align,
  placeholder,
  value,
  onChange,
  styleOverrides,
  isStudent,
}: SectionInputProps) => {
  const id = useId();
  const name = placeholder.toLowerCase().replaceAll(" ", "-");
  const qaSelector = `exportables-frayer-${name}-input`;
  const styles = { ...titleInputStyles(align), ...styleOverrides };

  return isStudent ? (
    <p css={{ ...paragraphStyles(align), ...styleOverrides }}>{value}</p>
  ) : (
    <input
      id={id}
      type="text"
      data-qa-selector={qaSelector}
      css={styles}
      value={value}
      placeholder={placeholder}
      aria-label={placeholder}
      maxLength={25}
      onChange={onChange}
      readOnly={isStudent}
    />
  );
};

export default SectionInput;
